(() => {
  const selector = '[data-ht-condition-badge]';
  const labels = window.HobbyTigerThemeStrings?.productCard || {};
  const conditions = window.HobbyTigerConditionData || {};
  let queued = false;

  const refresh = () => {
    queued = false;
    document.querySelectorAll(selector).forEach((badge) => {
      const condition = String(badge.dataset.htDatasetCondition || conditions[badge.dataset.htConditionHandle] || '').trim().toLowerCase();
      const kind = condition === 'used' ? 'used' : condition === 'brand new' || condition === 'brand-new' ? 'brand-new' : '';
      const priorityBadge = [...badge.parentElement.children].some((sibling) =>
        sibling !== badge && !sibling.hidden && sibling.matches('.badge, .ht-product__status-pill, .ht-hero-carousel__status-pill, .ht-badge--status')
      );
      const productPriority = badge.classList.contains('ht-badge--status')
        && !!badge.closest('.ht-product')?.querySelector('.ht-product__status-pill:not([data-ht-condition-badge]):not([hidden])');
      badge.hidden = !kind || priorityBadge || productPriority;
      if (!badge.hidden) badge.textContent = kind === 'used' ? labels.used || 'Used' : labels.brandNew || 'Brand New';
      badge.classList.toggle('ht-card-condition-badge--used', kind === 'used');
      badge.classList.toggle('ht-card-condition-badge--brand-new', kind === 'brand-new');
      badge.classList.toggle('ht-product__status-pill--used', kind === 'used' && badge.classList.contains('ht-product__status-pill'));
      badge.classList.toggle('ht-product__status-pill--brand-new', kind === 'brand-new' && badge.classList.contains('ht-product__status-pill'));
      badge.classList.toggle('ht-hero-carousel__status-pill--used', kind === 'used' && badge.classList.contains('ht-hero-carousel__status-pill'));
      badge.classList.toggle('ht-hero-carousel__status-pill--brand-new', kind === 'brand-new' && badge.classList.contains('ht-hero-carousel__status-pill'));
    });
  };

  const queueRefresh = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  };

  const start = () => {
    new MutationObserver((records) => {
      if (records.some((record) => record.type === 'attributes'
        ? !record.target.matches(selector)
        : [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        ))) queueRefresh();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    refresh();
  };

  window.HobbyTigerRefreshConditionBadges = queueRefresh;
  window.addEventListener('pageshow', queueRefresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
